import { StandardEvents } from '@shopify/events';

const PRODUCT_LINK_SELECTOR = '[data-whatsapp-contact="product"]';
const LISTENER_FLAG = Symbol.for('amna.whatsapp-contact.product-select-listener');
const requestGenerations = new WeakMap();

function useProductFallback(link) {
  const fallbackHref = link.dataset.whatsappProductFallbackHref;
  if (fallbackHref) link.href = fallbackHref;
  delete link.dataset.whatsappVariantId;
}

function findResolvedLink(html, productId, variantId) {
  const links = html?.querySelectorAll?.(PRODUCT_LINK_SELECTOR) ?? [];

  return Array.from(links).find(
    (link) =>
      link instanceof HTMLAnchorElement &&
      link.dataset.whatsappProductId === productId &&
      link.dataset.whatsappVariantId === variantId
  );
}

async function handleProductSelect(event) {
  if (!(event.target instanceof Element) || !event.promise) return;

  const section = event.target.closest('.shopify-section');
  const initialLink = section?.querySelector(PRODUCT_LINK_SELECTOR);
  if (!(section instanceof Element) || !(initialLink instanceof HTMLAnchorElement)) return;

  const generation = (requestGenerations.get(section) ?? 0) + 1;
  requestGenerations.set(section, generation);

  try {
    const result = await event.promise;
    if (requestGenerations.get(section) !== generation || !section.isConnected) return;

    const detail = result?.detail;
    const productId = detail?.productId == null ? '' : String(detail.productId);
    const currentLink = section.querySelector(PRODUCT_LINK_SELECTOR);

    if (
      !(currentLink instanceof HTMLAnchorElement) ||
      !productId ||
      currentLink.dataset.whatsappProductId !== productId
    ) {
      return;
    }

    const resource = detail?.resource;
    const variantId = resource?.id == null ? '' : String(resource.id);

    if (!variantId) {
      useProductFallback(currentLink);
      return;
    }

    const resolvedLink = findResolvedLink(detail?.html, productId, variantId);
    if (!(resolvedLink instanceof HTMLAnchorElement)) {
      useProductFallback(currentLink);
      return;
    }

    currentLink.href = resolvedLink.href;
    currentLink.dataset.whatsappVariantId = variantId;
  } catch {}
}

if (!window[LISTENER_FLAG]) {
  window[LISTENER_FLAG] = true;
  document.addEventListener(StandardEvents.productSelect, handleProductSelect);
}
